export default __webpack_public_path__ + "static/251449078_1589592581380841_1990357198560297341_n-187cfcebc018bcbd8c8c752cd5f8a5df.jpeg";